<template>
	<k-menu
		v-model="isActive"
		:close-on-content-click="false"
		:close-on-click="!persistent"
		v-bind="$attrs"
		@open="onOpen"
		@close="onClose"
	>
		<template v-slot:activator="{ on }">
			<div class="ks-edit-dialog-activator" v-on="on">
				<slot :is-active="isActive" :value="internalValue"></slot>
			</div>
		</template>

		<div
			class="ks-edit-dialog-content"
			:class="{ 'ks-edit-dialog-content-large': large }"
			@click.stop
			@keydown.esc.stop.prevent="onCancel"
			@keydown.enter.stop.prevent="onSave"
		>
			<slot name="input" :value="internalValue" :set-value="setInternalValue"></slot>

			<div v-if="!large" class="ks-edit-dialog-actions">
				<k-btn flat @click.stop="onCancel">{{ cancelText }}</k-btn>
				<k-btn flat color="green" @click.stop="onSave">{{ saveText }}</k-btn>
			</div>
		</div>
	</k-menu>
</template>

<script>
export default {
	name: "KEditDialog",
	inheritAttrs: false,
	props: {
		value: {
			type: Boolean,
			default: false
		},
		returnValue: {
			type: null,
			default: null
		},
		persistent: {
			type: Boolean,
			default: false
		},
		large: {
			type: Boolean,
			default: false
		},
		lazy: {
			type: Boolean,
			default: false
		},
		saveText: {
			type: String,
			default: "Save"
		},
		cancelText: {
			type: String,
			default: "Cancel"
		}
	},
	data () {
		return {
			isActive: this.value,
			internalValue: this.cloneValue(this.returnValue),
			originalValue: this.cloneValue(this.returnValue)
		}
	},
	watch: {
		value (val) {
			this.isActive = val
		},
		isActive (val) {
			this.$emit("input", val)
		},
		returnValue (val) {
			this.internalValue = this.cloneValue(val)
			if (!this.isActive) {
				this.originalValue = this.cloneValue(val)
			}
		}
	},
	methods: {
		cloneValue (val) {
			if (val === null || typeof val === "undefined") return val
			if (typeof val !== "object") return val
			try {
				return JSON.parse(JSON.stringify(val))
			} catch (e) {
				return val
			}
		},
		setInternalValue (val) {
			this.internalValue = val
		},
		onOpen () {
			this.originalValue = this.cloneValue(this.returnValue)
			this.internalValue = this.cloneValue(this.returnValue)
			this.$emit("open")
		},
		onClose () {
			this.$emit("close")
		},
		onSave () {
			this.$emit("update:returnValue", this.internalValue)
			this.$emit("save", this.internalValue)
			this.isActive = false
		},
		onCancel () {
			this.internalValue = this.cloneValue(this.originalValue)
			this.$emit("update:returnValue", this.internalValue)
			this.$emit("cancel", this.internalValue)
			this.isActive = false
		}
	}
}
</script>

<style>
.ks-edit-dialog-activator {
	display: inline-flex;
	align-items: center;
	cursor: pointer;
}

.ks-edit-dialog-content {
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 10px;
	min-width: 100px;
}

.ks-edit-dialog-content-large {
	min-width: 300px;
}

.ks-edit-dialog-actions {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 6px;
}
</style>
